/* Bordamar v13b · mejoras de la auditoría 16/10 (segunda tanda) */
(function () {
  /* 2-3 · El icono de cookies no tapa las barras fijas en móvil (se sube mientras hay barra) */
  function liftWidgets() {
    var on = window.innerWidth < 750 && (document.body.classList.contains('bm-sticky-on') || document.body.classList.contains('bm13-cartbar-on'));
    var host = document.querySelector('pandectes-cmp');
    var btn = host && host.shadowRoot && host.shadowRoot.querySelector('button.widget');
    if (btn) { btn.style.transition = 'bottom .3s ease'; btn.style.bottom = on ? '92px' : ''; }
  }
  try { new MutationObserver(liftWidgets).observe(document.body, { attributes: true, attributeFilter: ['class'] }); } catch (e) {}
  var lw = 0, lwi = setInterval(function () { liftWidgets(); if (++lw > 20) clearInterval(lwi); }, 1000);
  /* 5 · Colección: filtros cortos, en el idioma del cliente y ordenados */
  var TYPE_HIDE = ['BAÑADORES', 'BODIES', 'LEGGINGS', 'MASCARILLAS', 'PADDLE', 'PETOS DEPORTIVOS', 'CONJUNTOS DEPORTIVOS', 'ROPA DEPORTIVA', 'CHANDALS', 'BOLSAS', 'MOCHILAS'];
  var TYPE_FIRST = ['POLOS', 'CAMISETAS', 'PANTALONES', 'CAMISAS', 'SUDADERAS', 'CHAQUETAS', 'PARKAS', 'ALTA VISIBILIDAD', 'CALZADO', 'ZAPATO LABORAL', 'BATAS', 'DELANTALES', 'CHALECOS', 'PANTALONES CORTOS', 'POLARES', 'SOFTSHELLS'];
  var TYPE_NAME = { 'BUZOS - MONOS': 'Buzos y monos', 'REBECA-CARDIGAN': 'Rebecas y cárdigans', 'CALCETAS Y CALCETINES': 'Calcetines', 'ROPA ABRIGO': 'Ropa de abrigo' };
  var SIZE_ORDER = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '2XL', 'XXXL', '3XL', 'XXXXL', '4XL', '5XL', '6XL', '7XL'];
  var COLOR_FIRST = ['NEGRO', 'BLANCO', 'MARINO', 'AZUL MARINO', 'GRIS', 'GRIS OSCURO', 'ROJO', 'ROYAL', 'AZUL', 'VERDE', 'BEIGE', 'ARENA', 'GRANATE', 'CELESTE', 'NARANJA', 'AMARILLO'];
  function sentence(s) { s = (s || '').trim().toLowerCase(); return s.charAt(0).toUpperCase() + s.slice(1); }
  function rank(v, list) { var i = list.indexOf(v.trim().toUpperCase()); return i < 0 ? 999 : i; }
  function sizeKey(v) {
    v = v.trim().toUpperCase();
    var i = SIZE_ORDER.indexOf(v); if (i > -1) return [0, i];
    if (/^\d{2}$/.test(v)) return [1, +v];
    var k = v.match(/^(\d{1,2})\/(\d{1,2})$/); if (k) return [2, +k[1]];
    return [3, 0];
  }
  function arrange(ul, keyFn, n, label) {
    /* Ordena con CSS (order) en vez de mover nodos: así sobrevive a los repintados del filtro */
    var lis = [].slice.call(ul.children).filter(function (l) { return l.querySelector('input'); });
    var on = lis.filter(function (l) { return !l.classList.contains('bm13-off'); });
    var keyed = on.map(function (l, i) { return { l: l, k: keyFn(l.querySelector('input').value), i: i }; });
    keyed.sort(function (a, b) { for (var j = 0; j < a.k.length; j++) { if (a.k[j] !== b.k[j]) return a.k[j] - b.k[j]; } return a.i - b.i; });
    if (typeof n === 'function') n = n(keyed);
    keyed.forEach(function (o, idx) {
      var ord = String(idx + 1);
      if (o.l.style.order !== ord) o.l.style.order = ord;
      o.l.classList.toggle('bm13-x', idx >= n);
      o.l.classList.remove('mobile:hidden'); o.l.classList.remove('hidden');
    });
    lis.forEach(function (l) { if (l.classList.contains('bm13-off')) l.style.order = '9999'; });
    var sm = ul.closest('show-more-component'); if (sm) sm.classList.add('bm13-sm');
    var btn = ul.nextElementSibling && ul.nextElementSibling.classList.contains('bm13-more') ? ul.nextElementSibling : null;
    if (on.length > n) {
      ul.classList.add('bm13-lim');
      if (!btn) { btn = document.createElement('button'); btn.type = 'button'; btn.className = 'bm13-more'; btn.addEventListener('click', function () { ul.classList.add('bm13-open'); }); ul.after(btn); }
      var t = label + ' (' + on.length + ')'; if (btn.textContent !== t) btn.textContent = t;
    } else if (btn) { btn.remove(); }
  }
  function relabel(li, text) { var t = li.querySelector('.checkbox__label-text'); if (t && t.textContent.trim() !== text) t.textContent = text; }
  function facetsFix() {
    document.querySelectorAll('main ul.facets__inputs-list').forEach(function (ul) {
      var first = ul.querySelector('input[name^="filter."]'); if (!first) return;
      var name = first.name;
      if (name === 'filter.p.product_type') {
        [].forEach.call(ul.children, function (li) {
          var i = li.querySelector('input'); if (!i) return;
          var v = i.value.trim().toUpperCase();
          li.classList.toggle('bm13-off', TYPE_HIDE.indexOf(v) > -1);
          relabel(li, TYPE_NAME[v] || sentence(v));
        });
        arrange(ul, function (v) { return [rank(v, TYPE_FIRST)]; }, 10, 'Ver todas las prendas');
      } else if (name === 'filter.v.option.talla') {
        arrange(ul, sizeKey, function (k) { return Math.max(k.filter(function (o) { return o.k[0] === 0; }).length, 8); }, 'Ver todas las tallas');
      } else if (/^filter\.v\.option\.colou?r$/.test(name)) {
        [].forEach.call(ul.children, function (li) { var i = li.querySelector('input'); if (i) relabel(li, sentence(i.value)); });
        arrange(ul, function (v) { return [rank(v, COLOR_FIRST)]; }, 12, 'Ver todos los colores');
      }
    });
  }
  function initFacets() {
    var m = document.querySelector('main[data-template^="collection"], main[data-template^="search"]'); if (!m) return;
    facetsFix();
    var ft; new MutationObserver(function () { clearTimeout(ft); ft = setTimeout(facetsFix, 150); }).observe(m, { childList: true, subtree: true });
  }
  if (document.readyState !== 'loading') initFacets(); else document.addEventListener('DOMContentLoaded', initFacets);
  /* 6-7 · Textos coherentes e imagen premium */
  function textFix() {
    /* Menú: «Packs −10 %» daba a entender un −10 % siempre */
    document.querySelectorAll('header a, .menu-drawer a, header-menu a').forEach(function (a) {
      var t = a.childNodes.length === 1 && a.firstChild.nodeType === 3 ? a.firstChild : null;
      var el = t ? a : a.querySelector('span');
      if (!el) return;
      if (/^\s*packs\s*[−\-–]\s*10\s*%\s*$/i.test(el.textContent)) el.textContent = el.textContent.replace(/packs\s*[−\-–]\s*10\s*%/i, 'Packs por sector');
    });
    /* Reseñas de Google: «Publicado el Google» → «Publicado en Google» y sin botón de «Escribe una reseña» */
    var rv = document.querySelectorAll('#resenas');
    rv.forEach(function (r) {
      var w = document.createTreeWalker(r, NodeFilter.SHOW_TEXT);
      var n; while ((n = w.nextNode())) { if (/^\s*Publicado el\s*$/.test(n.nodeValue)) n.nodeValue = n.nodeValue.replace('Publicado el', 'Publicado en'); }
      r.querySelectorAll('a, button').forEach(function (b) { if (/^\s*escribe una reseña\s*$/i.test(b.textContent)) b.style.display = 'none'; });
    });
  }
  textFix();
  var tf; try { new MutationObserver(function () { clearTimeout(tf); tf = setTimeout(textFix, 250); }).observe(document.body, { childList: true, subtree: true }); } catch (e) {}
})();
